<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Item</th>
          <th class="text-right">Valor (R$)</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="clickable"
          v-for="item in values"
          :key="item.name"
          @click="$emit('itemClicked', item)"
        >
          <td>{{ item.name }}</td>
          <td class="text-right">{{ item.value | brDec }}</td>
        </tr>
        <tr v-if="values == null || values.length < 1">
          <td colspan="2">(Não existem items)</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { brDec } from 'oderon-commons/src/formatters.js'

export default {
  props: {
    values: { type: Array }
  },
  filters: {
    brDec(x) {
      return Number.isFinite(x) ? brDec(x) : '─'
    }
  }
}
</script>

<style></style>
